<template>
  <div
    class="select-wrap select-mounth coocaa_btn"
    :id="`select_${id}`"
    v-focusable
    :style="{
      'border': `${config.borderWidth}px solid ${config.borderColor}`,
      'background': config.background,
      'fontSize': `${config.fontSize}px`,
      'color': config.textColor
    }"
    @click.prevent.stop="openSelectPage"
  >
    <span
      class="text"
      :style="{
        'textAlign': config.textAlign
      }"
    >
      {{ showText }}
    </span>
    <span class="icon"><i class="el-icon-d-caret"></i></span>
  </div>
</template>

<script>
export default {
  name: 'SelectC',
  props: {
    chartData: {
      type: Array,
      default () {
        return []
      }
    },
    config: {
      type: Object,
      default () {
        return {}
      }
    },
    id: {
      type: [Number, String],
      default: ''
    }
  },
  computed: {
    showText () {
      let txt = ''
      const { DBAKey } = this.config
      const tempData = this.$store.state.app.selectVal
      const chooseItem = tempData.filter(item => {
        return DBAKey === item.type
      })
      if (this.config.isDate) {
        txt = this.$store.state.app.date.time
      } else {
        if (chooseItem.length) {
          txt = `${this.config.defaultText}：${chooseItem[0]['label']}`
        } else {
          txt = `${this.config.defaultText}：全部${this.config.defaultText}`
        }
      }
      return txt
    }
  },
  methods: {
    openSelectPage () {
      let data = {
        data: this.chartData,
        config: this.config
      }
      this.$emit('openSelectPage', data)
    }
  }
}
</script>

<style lang="stylus" scoped>
.select-wrap
  width 100%
  height 100%
  box-sizing border-box
  padding 10px
  display flex
  align-items center
  cursor pointer
  border-radius 4px
  .text
    flex 1
  .icon
    display inline-block
    width 20px
.select-wrap.btnFocus
  background #007eff !important
  color #fff !important
</style>
